import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DynamicFormContactModelBase from '../_generated/modelBases/dynamic-form-contact-model-base';
import DynamicFormContactDTO from '../_generated/dto/dynamic-form-contact-dto';

export default class DynamicFormContactModel extends DynamicFormContactModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs

  constructor(data?: DeepPartial<DynamicFormContactDTO>) {
    super(data);
    // Email has the incorrect letter casing in the v2 models
    this.email = (data as any)?.eMail;
  }

  get eMail() { return this.email; }

  set eMail(value) { this.email = value; }
}
